import { IdentityReferenceItem } from '@reg/shared/model';

/**
 * Model to a ranking priority reference item
 */
export class IdentityRankingPriority extends IdentityReferenceItem {
    public static ID_PLACEMENT_POINTS: string = '7c12204d-8939-9817-abae-e5099b7f6405';
    public static INSTANCE_OF_NAME: string = 'RankingPriority';

    public clone(): IdentityRankingPriority {
        return <IdentityRankingPriority> super.clone();
    }

    public deserialize(json: Object): IdentityRankingPriority {
        return <IdentityRankingPriority> super.deserialize(json);
    }
}
